import script from "./packagesDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./packagesDashboard.vue?vue&type=script&setup=true&lang=js"

import "./packagesDashboard.vue?vue&type=style&index=0&id=48a4a06c&scoped=true&lang=css"

import exportComponent from "E:\\Awamer work\\my projects\\Nuxt\\A new work\\saqf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a4a06c"]])

export default __exports__